export interface JSONCustomerSettingName {
    [key: string]: unknown;
}

// User defined values based on active customer settings
export enum CustomerSettingCategory {
    MIJN_KLANT = 'ap-mijn-klant'
}

export enum CustomerSettingName {
    MIJN_BETALEN_USABILLA_VERBERGEN = 'ap-mijn-betalen.usabilla-verbergen',
    MIJN_KLANT_FIRST_TIME_USE_TOUR = 'ap-mijn-klant.first-time-use.tour',
    MIJN_KLANT_FIRST_TIME_USE_FEATURES = 'ap-mijn-klant.first-time-use.features',
    MIJN_KLANT_REKENINGEN = 'ap-mijn-klant.rekeningen',
    MIJN_KLANT_VOORKEURSREKENING_ID = 'ap-mijn-klant.voorkeursrekening-id',
    MIJN_OVERZICHT_TOTAALSALDO_WEERGEVEN = 'ap-mijn-klant.mijn-overzicht.totaalsaldo-weergeven',
    MIJN_OVERZICHT_LAST_FEEDBACK_MOMENT = 'ap-mijn-klant.mijn-overzicht.last-feedback-moment',
    MIJN_OVERZICHT_REKENING_SELECTIE = 'ap-mijn-overzicht.rekening-selectie',
    MIJN_OVERZICHT_PRODUCT_GROUP_ORDER = 'ap-mijn-overzicht.producten-volgorde',
    MIJN_OVERZICHT_PRODUCT_CATEGORIE_ORDER = 'ap-mijn-klant.productcategorie-volgorde',
    MIJN_REKENING_BULK_CATEGORIE_AANPASSEN_NOTIFICATIE_WEERGEVEN = 'ap-mijn-klant.mijn-rekening.bulk-categorie-aanpassen-notificatie-weergeven',
    MIJN_REKENING_FIRST_TIME_USE_TOUR = 'ap-mijn-klant.mijn-rekening.first-time-use.tour',
    MIJN_REKENING_FIRST_TIME_USE_SPAARPOTTEN = 'ap-mijn-klant.mijn-rekening.first-time-use.spaarpotten',
    MIJN_REKENING_GEWEIGERDE_OVERBOEKINGEN_NOTIFICATION = 'ap-mijn-klant.mijn-rekening.geweigerdeoverboekingen-notificatie-afgesloten',
    MIJN_REKENING_LAST_DOWNLOAD = 'ap-mijn-klant.mijn-rekening.last-download',
    MIJN_REKENING_NOTIFICATIES_WEERGEVEN = 'ap-mijn-klant.mijn-rekening.notificaties-weergeven',
    MIJN_REKENING_OMSCHRIJVING_TRANSACTIES_WEERGEVEN = 'ap-mijn-klant.mijn-rekening.omschrijving-transacties-weergeven',
    MIJN_SPAARPOT_VOLGORDE = 'mijn-spaarpot.volgorde',
    MIJN_OVERZICHT_SALDI_VERBERGEN = 'ap-mijn-klant.mijn-overzicht.saldi-verbergen',
    MIJN_OVERZICHT_INZICHT_IN_GELD_VERBERGEN = 'ap-mijn-klant.mijn-overzicht.inzicht-in-geld-verbergen',
    MIJN_OVERZICHT_HYPOTHEKEN_VERBERGEN = 'ap-mijn-klant.mijn-overzicht.hypotheken-verbergen',
    MIJN_OVERZICHT_VERZEKEREN_VERBERGEN = 'ap-mijn-klant.mijn-overzicht.verzekeren-verbergen',
    MIJN_GELD_INZICHT_PRIVACY_NOTIFICATION = 'ap-mijn-klant.mijn-geld-inzicht.privacy-notification',
    MIJN_OMGEVING_SURVEYS = 'ap-mijn-klant.surveys',
    MIJN_GELD_FEEDBACK = 'mijn-geld.feedback',
    MIJN_GELD_FIRST_TIME_USE = 'mijn-geld.first-time-use.features',
    MIJN_GELD_NOTIFICATIONS = 'mijn-geld.notifications',
    MIJN_VASTE_LASTEN_EXPENSE_PERIOD = 'mijn-vaste-lasten.expense-period'
}

export type CustomerSettingValue<T = CustomerSettingName> = T extends CustomerSettingName.MIJN_BETALEN_USABILLA_VERBERGEN
    ? HideUsabillaSettings
    : T extends CustomerSettingName.MIJN_KLANT_FIRST_TIME_USE_TOUR
      ? boolean
      : T extends CustomerSettingName.MIJN_KLANT_FIRST_TIME_USE_FEATURES
        ? string
        : T extends CustomerSettingName.MIJN_KLANT_REKENINGEN
          ? MijnKlantRekeningen
          : T extends CustomerSettingName.MIJN_KLANT_VOORKEURSREKENING_ID
            ? number
            : T extends CustomerSettingName.MIJN_OVERZICHT_TOTAALSALDO_WEERGEVEN
              ? boolean
              : T extends CustomerSettingName.MIJN_OVERZICHT_LAST_FEEDBACK_MOMENT
                ? string
                : T extends CustomerSettingName.MIJN_REKENING_BULK_CATEGORIE_AANPASSEN_NOTIFICATIE_WEERGEVEN
                  ? boolean
                  : T extends CustomerSettingName.MIJN_REKENING_FIRST_TIME_USE_TOUR
                    ? string
                    : T extends CustomerSettingName.MIJN_REKENING_FIRST_TIME_USE_SPAARPOTTEN
                      ? string
                      : T extends CustomerSettingName.MIJN_REKENING_GEWEIGERDE_OVERBOEKINGEN_NOTIFICATION
                        ? MijnRekeningGeweigerdeOverboekingenNotification
                        : T extends CustomerSettingName.MIJN_REKENING_LAST_DOWNLOAD
                          ? MijnRekeningLastDownload
                          : T extends CustomerSettingName.MIJN_REKENING_NOTIFICATIES_WEERGEVEN
                            ? Record<MijnRekeningNotificatieType, boolean>
                            : T extends CustomerSettingName.MIJN_REKENING_OMSCHRIJVING_TRANSACTIES_WEERGEVEN
                              ? Record<number, boolean>
                              : T extends CustomerSettingName.MIJN_SPAARPOT_VOLGORDE
                                ? MijnSpaarpotVolgorde
                                : T extends CustomerSettingName.MIJN_OVERZICHT_SALDI_VERBERGEN
                                  ? boolean
                                  : T extends CustomerSettingName.MIJN_OVERZICHT_INZICHT_IN_GELD_VERBERGEN
                                    ? boolean
                                    : T extends CustomerSettingName.MIJN_OVERZICHT_HYPOTHEKEN_VERBERGEN
                                      ? boolean
                                      : T extends CustomerSettingName.MIJN_OVERZICHT_VERZEKEREN_VERBERGEN
                                        ? boolean
                                        : T extends CustomerSettingName.MIJN_GELD_INZICHT_PRIVACY_NOTIFICATION
                                          ? boolean
                                          : T extends CustomerSettingName.MIJN_OMGEVING_SURVEYS
                                            ? string
                                            : T extends CustomerSettingName.MIJN_GELD_FEEDBACK
                                              ? Record<string, boolean>
                                              : T extends CustomerSettingName.MIJN_GELD_FIRST_TIME_USE
                                                ? string
                                                : T extends CustomerSettingName.MIJN_OVERZICHT_REKENING_SELECTIE
                                                  ? string
                                                  : T extends CustomerSettingName.MIJN_OVERZICHT_PRODUCT_GROUP_ORDER
                                                    ? string
                                                    : T extends CustomerSettingName.MIJN_GELD_NOTIFICATIONS
                                                      ? Record<string, boolean>
                                                      : T extends CustomerSettingName.MIJN_VASTE_LASTEN_EXPENSE_PERIOD
                                                        ? FixedExpensePeriod
                                                        : never;

export interface MijnKlantRekeningen {
    rekeningen: MijnKlantRekening[];
}

export interface MijnKlantRekening {
    id: number;
    alias: string;
    weergeven: boolean;
    weergeven_mobiel?: boolean;
    spaarpotten_weergeven?: boolean;
    type: MijnKlantRekeningType;
    account_id?: string;
    product_group?: string;
}

export enum MijnKlantRekeningType {
    PAYMENT_ACCOUNT = 'payment_account',
    SAVINGS_ACCOUNT = 'savings_account',
    INVESTMENT_ACCOUNT = 'investment_account',
    LOAN_ACCOUNT = 'loan_account',
    MANAGED_ACCOUNT = 'managed_account'
}

export interface MijnRekeningGeweigerdeOverboekingenNotification {
    settings: {
        rekeningId: number;
        datum: string;
    }[];
}

export interface MijnRekeningLastDownload {
    [key: number]: {
        date: string;
        filterNulboekingen: boolean;
        fileFormat: string;
        transactieReferentieId?: string;
    };
}

export interface MijnSpaarpotVolgorde {
    [rekeningId: number]: string[];
}

export enum MijnRekeningNotificatieType {
    TRANSACTIE_DETAILS_OMSCHRIJVING = 'transactie-details-omschrijving'
}

export enum FixedExpensePeriod {
    MONTH = 'month',
    YEAR = 'year'
}

export interface HideUsabillaSettings {
    settings: HideUsabillaPage[];
}

export interface HideUsabillaPage {
    name: string;
    hide: boolean;
}
